/**
 * @param props
 */

export default (props) => {
    return {
        query: {

        },
        range: {
            start: 0,
            finish: 40,
            offset: 0,
            width: 0,
        },
        mounted() {
            if ( !this.device.mobile ) {
                this.modules.video.filter = true;
            }

            const searchQuery = window.location.search.length ? window.location.search.substring(1) : '';

            if ( searchQuery.length) {
                this.query = new URLSearchParams(searchQuery);
            }

            this.range = {
                start: this.query.hasOwnProperty('d1') ? parseInt(this.query.d1): 0,
                finish: this.query.hasOwnProperty('d2') ? parseInt(this.query.d2) : 40,
                offset: (this.query.hasOwnProperty('d1') ? parseInt(this.query.d1): 0)/40*100,
                width: (this.query.hasOwnProperty('d2') ? parseInt(this.query.d2) : 40)/40*100 - ((this.query.hasOwnProperty('d1') ? parseInt(this.query.d1): 0)/40*100),
            };

            this.duration(this.$refs.startElement);
            this.duration(this.$refs.finishElement);
        },
        duration(element) {
            const max = element.getAttribute("max");
            const name = element.getAttribute("name");
            const step = element.getAttribute("step");
            element.addEventListener('input', () => {
                if ( name === 'finish' && this.range[name] < this.range.start + parseInt(step) ) {
                    this.range.finish = this.range.start + parseInt(step);
                }
                if ( name === 'start' && this.range[name] > this.range.finish - parseInt(step) ) {
                    this.range.start = this.range.finish - parseInt(step);
                }
                this.range.offset = this.range.start/parseInt(max)*100;
                this.range.width = this.range.finish/parseInt(max)*100 - this.range.offset;

                this.query.d1 = this.range.start;
                this.query.d2 = this.range.finish;
                delete this.query.page;
                window.location.href = window.location.pathname + '?' + new URLSearchParams(this.query).toString();
            });
        },
    }
};
